import { dataHooks } from '@wix/data-hooks';

export const exploreDataHooks = dataHooks<{
  container: {};
  errorState: {};
  emptyState: {};
  briefAutoMatch: {};
  bannerTitle: {};
  title: {};
  mobileContainer: {};
}>('explore-page');
